export enum EanEligibilityStatusEnum {
  Success,
  Conflict,
  Invalid,
  NotEligible,
  ContractNotFound,
  ContractNotRegisteredWithEmail,
  AskConsent,
  Existing,
  DeleteRequest,
  ConflictRequest,
  NotYearlyMetering,
  NoActiveDevice,
}
